import { useState } from "react";
import { Gift } from "lucide-react";

export const ukToday = () => new Date().toLocaleDateString("en-CA", { timeZone: "Europe/London" });
export const addDays = (iso, n) => {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};
export const niceDate = (iso) => new Date(`${iso}T12:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
export const longDate = (iso) => /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T12:00:00Z`).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }) : "";

function VoucherLogo() {
  const [failed, setFailed] = useState(false);
  if (failed) return <p className="font-serif text-2xl tracking-[0.25em] text-[#EDE6F7] mb-4">MEMORIES FOREVER</p>;
  return <img src="/brand/Memories_Forever_Logo_voucher.png" alt="Memories Forever" onError={() => setFailed(true)} className="h-14 sm:h-16 mx-auto mb-4 object-contain" />;
}

export function VoucherCard({ recipient, buyer, message, code, validUntil, includes, testid = "voucher-card" }) {
  return (
    <div className="relative rounded-3xl border border-[#8B2CFF] bg-[#1A1222] px-6 py-8 sm:px-10 sm:py-10 text-center shadow-[0_0_60px_rgba(139,44,255,0.25)]" data-testid={testid}>
      <VoucherLogo />
      <p className="eyebrow mb-2">A gift for</p>
      <p className="font-serif text-3xl sm:text-4xl text-[#EDE6F7] break-words" data-testid={`${testid}-recipient`}>{recipient || "…"}</p>
      {message && <p className="font-cormorant italic text-xl text-[#D2CBE0] mt-4 leading-relaxed break-words" data-testid={`${testid}-message`}>“{message}”</p>}
      <p className="text-[#B9B3C8] mt-4" data-testid={`${testid}-from`}>With love from {buyer || "…"}</p>
      <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#8B2CFF] bg-[#241634] px-6 py-3">
        <Gift className="h-5 w-5 text-[#B57BFF]" aria-hidden="true" />
        <span className="text-xl sm:text-2xl tracking-[0.2em] font-semibold text-[#F6F1FD]" data-testid={`${testid}-code`}>{code || "MF-····-····"}</span>
      </div>
      {validUntil && <p className="text-sm text-[#A49CB8] mt-3" data-testid={`${testid}-valid`}>Valid until {validUntil}</p>}
      {includes && <p className="text-sm text-[#C9B6FF] mt-4 max-w-md mx-auto" data-testid={`${testid}-includes`}>Includes {includes}.</p>}
    </div>
  );
}
